import {
  ArrowLeftOutlined,
  ArrowRightOutlined,
  CheckOutlined,
  DownloadOutlined,
  FileOutlined,
  FilePdfOutlined,
  FileZipOutlined,
  MinusOutlined,
  PlusOutlined,
} from '@ant-design/icons';
import { assertNever } from '../../../../../../utils/assertNever';
import { IIconType, IconType } from './Icons';

/**
 * Ottiene l'oggetto con icona e label di un'icona dato un tipo
 */
export const getIconLabelAndComponent = (type: IconType): IIconType => {
  switch (type) {
    case IconType.ArrowRightOutlined:
      return {
        icon: <ArrowRightOutlined aria-hidden="true" />,
        type: IconType.ArrowRightOutlined,
        label: 'Freccia Destra',
      };
    case IconType.ArrowLeftOutlined:
      return {
        icon: <ArrowLeftOutlined aria-hidden="true" />,
        type: IconType.ArrowLeftOutlined,
        label: 'Freccia Sinistra',
      };
    case IconType.PlusOutlined:
      return {
        icon: <PlusOutlined aria-label="Aggiungi" aria-hidden="true" />,
        type: IconType.PlusOutlined,
        label: 'Piu',
      };
    case IconType.MinusOutlined:
      return {
        icon: <MinusOutlined aria-label="Rimuovi" aria-hidden="true" />,
        type: IconType.MinusOutlined,
        label: 'Meno',
      };
    case IconType.CheckOutlined:
      return {
        icon: <CheckOutlined aria-label="Visto" aria-hidden="true" />,
        type: IconType.CheckOutlined,
        label: 'Visto',
      };
    case IconType.Nessuna:
      return {
        icon: undefined,
        type: IconType.Nessuna,
        label: 'Nessuna',
      };
    case IconType.FilePdfOutlined:
      return {
        icon: <FilePdfOutlined aria-label="File Pdf" aria-hidden="true" />,
        type: IconType.FilePdfOutlined,
        label: 'PDF',
      };
    case IconType.FileZipOutlined:
      return {
        icon: <FileZipOutlined aria-label="File Zip" aria-hidden="true" />,
        type: IconType.FileZipOutlined,
        label: 'ZIP',
      };
    case IconType.DownloadOutlined:
      return {
        icon: <DownloadOutlined aria-label="Scarica" aria-hidden="true" />,
        type: IconType.DownloadOutlined,
        label: 'Download',
      };
    case IconType.FileOutlined:
      return {
        icon: <FileOutlined aria-label="File" aria-hidden="true" />,
        type: IconType.FileOutlined,
        label: 'File',
      };
  }
  assertNever(type);
};
